module.exports = __webpack_public_path__ + "img/PostgreSQL.a02da199.png";